export function GetRandomNumber(numberOf:number){
    return Math.floor(Math.random() * numberOf)
}

export function CapitaliseWords(words:string) {
    return words.split(' ')
      .map(word => {
        if (!word) {
          return ""; // Handle empty words (e.g., multiple spaces)
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }